import styled, { createGlobalStyle } from "styled-components";
import { Link } from "react-router-dom";

export const CurrentTheme = {
  cOne: "51, 68, 85", // Dark Blue #334455
  cTwo: "0, 145, 234", // Light Blue #0091ea
  cThree: "241, 241, 241", // Gray

  white: "255, 255, 255",
  black: "0,0,0",

  blue: "41,98,255", //#2962ff
  orange: "245, 87, 34", // #F55722
  red: "213, 0, 0", // #d50000
  green: "0, 200, 83", // #00c853

  blueGray: "55, 71,79", // 37474f

  fSM: `font-size: 12px`,
  fDF: `font-size: 14px`,
  fMD: `font-size: 16px`,
  fLG: `font-size: 18px`,
  fGR: `font-size: 20px`,
  fXL: `font-size: 22px`,
  fXXL: `font-size: 28px`,

  gSM: "5px",
  gMD: "10px",
  gLG: "15px",
  gXL: "20px",

  primaryFont: `font-family: "Raleway", sans-serif`,
  secondaryFont: `font-family:  Arial`,

  mMX_XXS: "@media (max-width: 400px)",
  mMX_XS: "@media (max-width: 480px)",
  mMX_FOOTER: "@media (max-width: 645px)",
  mMX_SM: "@media (max-width: 768px)",
  mMX_MD: "@media (max-width: 991px)",
  mMX_LG: "@media (max-width: 1100px)",
  mMX_XL: "@media (max-width: 1200px)",
};
export const GlobalStyle = createGlobalStyle`
    ${(props) => {
      let current = props.theme;
      return `
      .nameLabel{
        z-index:9999!important;
        color:rgba(${current.cOne}, 1)!important;
        margin-top:-30px!important;
        font-weight:bold;
      }
        div[title="0"], div[title="1"], div[title="2"], div[title="3"], div[title="4"]{
          opacity:1!important;
          border-radius:50%;
          display:flex;
          justify-content:center;
          align-items:center;
          overflow:unset!important;
          width:20px!important;
          height:20px!important;
          position: absolute;
  
          >img{
            position:unset!important;
            z-index:1;
          }
        }
        div[title="0"]::after, div[title="1"]::after, div[title="2"]::after, div[title="3"]::after, div[title="4"]::after{
          position: absolute;
          content: '';
          width: 0px;
          height: 0px;
          bottom: -19px;
          left: 0;
          border: 10px solid transparent;
          border-top: 17px solid #fff;

        }
        div[title="0"]{
          background:#3E51B4;
        }
        div[title="0"]::after{
          color:#3E51B4;
          border-top-color:#3E51B4;
        }
        div[title="1"]{
          background:#4BAF50;
        }
        div[title="1"]::after{
          color:#4BAF50;
          border-top-color:#4BAF50;;
        }
        div[title="2"]{
          background:#F65722;
        }
        div[title="2"]::after{
          color:#F65722;
          border-top-color:#F65722;;
        }
        div[title="3"]{
          background:#F34435;
        }
        div[title="3"]::after{
          color:#F34435;
          border-top-color:#F34435;;
        }
        div[title="4"]{
          background:#ffd600;
        }
        div[title="4"]::after{
          color:#ffd600;
          border-top-color:#ffd600;;
        }
        body, html{
            background:rgba(${current.black},0.0015)!important;
            height: 100%!important;
            overflow: hidden!important;
            -webkit-overflow-scrolling: touch;
        
            margin: 0!important;
            padding: 0!important;
            min-width: unset!important;
            ${current.primaryFont}!important;
            ${current.fDF}!important;
            line-height: 1.4285em!important;
            color: rgba(${current.black}, 0.87);
          }
          * {
            margin: 0;
            padding: 0;
          }
          h1,h2,h3,h4,h5,h6{
            ${current.primaryFont}!important;
            margin: 0;
            padding: 0;
          }
          a{
            text-decoration: none;
          }
          #root {
            height: 100%!important;
            position:relative;
          }

          .MuiOutlinedInput-notchedOutline{
            border-color:rgba(${current.black},0.0625)!important;
            border-width:1px!important;
            background: rgb(${current.white});
          }
          .error{
            .MuiOutlinedInput-notchedOutline{
              border-color:rgb(${current.red})!important;
            }
            textarea{
              border-color:rgb(${current.red})!important;
            }
          }
          .gm-style-iw>button.gm-ui-hover-effect{
            display:none!important;
          }
          .gm-style .gm-style-iw-t::after{
            background:unset!important;
            box-shadow:unset!important;
          }
          .gm-style-iw-t{
            bottom: -90px!important;
          }
          .gm-style .gm-style-iw-c,
          .gm-style .gm-style-iw-t::after{
            top:-32px!important;
          }

          .reportDatePicker{
            margin-bottom: 0!important;
            width: 70px!important;
            display: flex!important;
            .MuiOutlinedInput-input{
              padding:0!important;
            }
            .MuiOutlinedInput-notchedOutline{
              border-width:0!important;
            }
            .MuiInputBase-root{
              ${current.fSM};
              font-family: "os-regular"!important;
              color:rgba(${current.black},0.6)!important;
            }
            .MuiInputBase-input{
              z-index:1;
            }
          }
          .hide{
            opacity:0!important;
          }
          .withMargin, .withMargin.MuiFormControl-root{
            margin-bottom:${current.gXL}!important;
          }


          .btn-primary{
            color:rgb(${current.white})!important;
            background:rgb(${current.green})!important;
            border:1px solid rgb(${current.green})!important;
            :hover{
              color:rgb(${current.white})!important;
              background:rgb(${current.green},0.9)!important;
              border:1px solid rgb(${current.green})!important;
            }
          }
          .btn-secondary{
            color:rgb(${current.white})!important;
            background:rgb(${current.cOne})!important;
            border:1px solid rgb(${current.cOne})!important;
            :hover{
              color:rgb(${current.white})!important;
              background:rgb(${current.cOne},0.9)!important;
              border:1px solid rgb(${current.cOne})!important;
            }
          }
          .btn-danger{
            color:rgb(${current.white})!important;
            background:rgb(${current.red})!important;
            border:1px solid rgb(${current.red})!important;
            :hover{
              color:rgb(${current.white})!important;
              background:rgb(${current.red},0.9)!important;
              border:1px solid rgb(${current.red})!important;
            }
          }
          button:disabled,
          button[disabled]{
            color: rgba(0, 0, 0, 0.2)!important;
            background: rgba(0, 0, 0, 0.0625)!important;
            border: 1px solid rgba(0, 0, 0, 0.0625)!important;
            :hover{
              color: rgba(0, 0, 0, 0.2)!important;
              background: rgba(0, 0, 0, 0.0625)!important;
              border: 1px solid rgba(0, 0, 0, 0.0625)!important;
            }
          }

          .MuiInputBase-root.Mui-disabled *, .disabled *{
            color: rgba(0, 0, 0, 0.1625)!important;
            border-color: rgba(0, 0, 0, 0.1625)!important;
          }

          .noMargin{
            margin:0!important;
          }
          .fullWidth{
            width:100%!important;
          }
          .autocomplete .search ul li>div>span, .selected>div>span{
            color:rgba(${current.white},1);
          }
          .widthFixed{
            width:auto!important;
          }
        `;
    }}
`;

export const SelectedEquipmentForReportStyled = styled.div`
  ${(props) => {
    let current = props.theme;
    return `
    padding:${current.gMD};
        .title{
          margin-bottom:${current.gMD};
          color:rgb(${current.blueGray});
          font-weight:600;
        }
      `;
  }}
`;

export const CardHeader = styled.h3`
  ${(props) => {
    let current = props.theme;
    return `
  border-bottom:1px solid rgba(${current.black}, 0.0625);
  display:flex;
  justify-content: stretch;
  width:100%;
  .detail{
    flex-grow:1;
    display:flex;
    flex-direction: column;
    align-self: stretch;
    justify-content: center;
    padding:${current.gSM};
    color:rgba(${current.blueGray});
    min-height: 56px;
    >span{
      font-weight:400;
      ${current.fDF};
      >b{
        ${current.secondaryFont};
      }
    }
    :hover{
      background:none;
    }
  }
  >div{
    display:flex;
    flex-direction: column;
    justify-content: center;
    width: 56px;
  }
  >span{
    align-self: center;
    cursor:pointer;
    height: 100%;
    color:rgba(${current.black},0.5);
    >svg{
      height: 100%;
      padding: 0px 10px;
      font-size: 42px;
      :hover{
        background:rgba(${current.black},0.0625);
      }
    }
  }
  .active{
    background:rgba(${current.black},0.0625);
  }

  svg.mainIcon{
    align-self: center;
    ${current.fXL};
    cursor:pointer;
    font-size: 26px;
    color:rgba(${current.black},0.5);
    margin-bottom: -4px;
    margin:0 ${current.gSM};
  }
`;
  }}
`;

export const CardFilter = styled.div`
  ${(props) => {
    let current = props.theme;
    return `
    padding:${current.gMD};
    border-bottom:1px solid rgba(${current.black}, 0.0625);
  `;
  }}
`;

export const OuterWrapper = styled.div`
  ${(props) => {
    let current = props.theme;
    return `
      ${
        props.height &&
        `
        height:${props.height}px;
      `
      };
      ${current.mMX_MD}{
        height:auto;
        max-height:${props.height}px;
        overflow-y:auto;
      }
    `;
  }}
`;

export const CardBody = styled.div`
  ${(props) => {
    let current = props.theme;
    return `
    flex-grow:1;
    width:100%;
    ${
      props.position &&
      `
      position:relative;
    `
    };
    ${
      props.height &&
      `
      overflow:auto;
      height:${props.filter ? props.height - props.filter : props.height}px;
      max-height:${props.filter ? props.height - props.filter : props.height}px;
    `
    };
    ${current.mMX_MD}{
      ${
        props.map &&
        `
        overflow:auto;
        height:${props.filter ? props.height - props.filter : props.height}px;
        max-height:${
          props.filter ? props.height - props.filter : props.height
        }px;
      `
      };
      ${
        !props.map &&
        `    
        overflow:unset;
        height:auto;
        max-height:unset;
      `
      };
    }
  `;
  }}
`;
export const ListStyled = styled.div`
  ${(props) => {
    let current = props.theme;
    return `
    border-bottom:1px solid rgba(${current.black}, 0.0625);

    cursor:pointer;
    :hover{
      background:rgba(${current.black}, 0.0625);
      border-bottom:1px solid rgba(${current.black}, 0.3);
    }
    ${
      props.isActive &&
      `
    background:rgba(${current.cTwo}, 0.1);
    border-bottom:1px solid rgba(${current.cTwo}, 0.3);
    `
    };
    display:flex;
    .action{
      display:flex;
      align-items:center;
    }
    >span{ 
      display:flex;
      align-items:center;
      padding:0 ${current.gMD};
      :hover{
        background:rgba(${current.black},0.1);
      }
    }
    span.error{
      color:rgb(${current.cOne})!important;
    }
    .add{
      color:rgb(${current.green})!important;
      :hover{
        background:rgb(${current.green})!important;
        color:rgb(${current.white})!important;
        >svg{
          color:rgb(${current.white})!important;
        }
      }
    }
    .disable{
      color:rgba(${current.black},0.3)!important;
      :hover{
        background:unset!important;
        color:unset!important;
        >svg{
          color:unset!important;
        }
      }
    }
    .edit{
      color:rgb(${current.blue})!important;
      :hover{
        background:rgb(${current.blue})!important;
        color:rgb(${current.white})!important;
        >svg{
          color:rgb(${current.white})!important;
        }
      }
    }
    .delete, .remove{
      color:rgb(${current.red})!important;
      :hover{
        background:rgb(${current.red})!important;
        color:rgb(${current.white})!important;
        >svg{
          color:rgb(${current.white})!important;
        }
      }
    }
    >div.detail{
      padding:${current.gMD};
      ${props.equipment && `padding:4px ${current.gMD}`};
      ${props.route && `padding:12px ${current.gMD}`};
      display:flex;
      flex-direction: column;
      font-weight:600;
      flex-grow:1;
      ${current.fDF};
      color:rgba(${current.blueGray},1);
      span{
        font-weight:400;
        ${current.fSM};
        color:rgba(${current.black},0.3)!important;
        >b{
          font-weight:600;
          ${current.secondaryFont};
        }
      }
    }
  `;
  }}
`;
export const StateList = styled.div`
  ${(props) => {
    let current = props.theme;
    return `
    display:flex;
    justify-content: center;
    flex-direction: column;
    align-items: flex-end;
    margin-right:${current.gMD};
    font-weight:400;
  `;
  }}
`;
export const CardStyled = styled.div`
  ${(props) => {
    let current = props.theme;
    return `
      border:1px solid rgba(${current.black}, 0.0625);
      background:rgb(${current.white});
      height:100%;
      width:100%;
      flex-direction: column;
      display:flex;
      border-radius:4px;
    `;
  }}
`;
export const RootWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const HeaderStyled = styled.div`
  ${(props) => {
    let current = props.theme;
    return `
    height:60px;
    min-height:60px;
    background:rgb(${current.cOne});
    color:rgb(${current.white});
    display:flex;
    align-items: center;
    justify-content:space-between;

    .loginSwitchLanguage {
      display: flex;
      margin-left:auto;
      margin-right:${current.gMD};

      .switchLanguage {
        width: 200px !important;
      }
    }
    ${current.mMX_XS} {
        min-height:110px;
        padding:${current.gMD};
        flex-direction: column;

        .loginSwitchLanguage {
          margin-top:${current.gSM};
          margin-left:unset!important;
          margin-right:unset!important;
        }
    }
        `;
  }}
`;

export const BodyRootWrapper = styled.div`
  ${(props) => {
    return `
        flex-grow:1;
        ${
          props.floatFooter &&
          `
        display: flex;
        flex-direction: column;
        `
        };
        ${
          !props.floatFooter &&
          `
            overflow-x:auto;
          `
        };
          ${
            props.login &&
            `
            justify-content: center;
            align-items: center;
          `
          }
      `;
  }}
`;

export const BodyWrapper = styled.div`
  ${(props) => {
    return `
    display:flex;
    flex-direction: column;
   
    ${
      !props.login &&
      `
      flex-grow:1;
    `
    };
    ${
      props.login &&
      `
      justify-content: center;
      align-items: center;
    `
    };
    `;
  }}
`;

export const LinkStyled = styled(Link)`
  ${(props) => {
    let current = props.theme;
    return `
      color:rgb(${current.cOne});
      text-align: center;
      display: block;
      padding-top: ${current.gLG};
        :hover{
          color:rgb(${current.cThree});
        }
    `;
  }}
`;

export const BodyStyled = styled.div`
  ${(props) => {
    return `
    flex-grow:1;
    display:flex;
    ${
      !props.emailVerified &&
      `
      align-items: center;
      justify-content: center;
    `
    };
    `;
  }}
`;

export const HeadingOne = styled.h1`
  ${(props) => {
    let current = props.theme;
    return `
    ${current.fXL};
    ${current.primaryFont};
    color:rgb(${current.blueGray});
    margin-bottom:${current.gMD};
    font-weight:400;
    display:flex;
    flex-direction:column;
    >span{
      color:rgb(${current.black},0.3);
      ${current.fDF};
      margin:${current.gSM};
    }
    ${
      props.marginBottom &&
      `
    margin-bottom:${props.marginBottom}px!important;
    `
    };
    ${
      props.textCenter &&
      `
        text-align:center;
    `
    }
    `;
  }}
`;

export const FilterByStyled = styled.div`
  ${(props) => {
    let current = props.theme;
    return `
      display:flex;
      height:100%;
      flex-direction:column;
      padding:${current.gMD};
      padding-top:${current.gXL};
      .buttonClass{
        margin-top:auto;
      }
    `;
  }}
`;

export const BodyWrapperStyled = styled.section`
  ${(props) => {
    return `
      display:flex;
      flex-wrap:wrap;
      justify-content: space-between;
      ${
        props.fullHeight &&
        `
        height:100%;
      `
      };
    `;
  }}
`;

export const BoxStyled = styled.div`
  ${(props) => {
    let current = props.theme;
    let width = "100%";
    let gap = 0;
    let col = props.col;
    if (col) {
      if (col === "4") {
        gap = 60;
      }
      if (col === "3") {
        gap = 40;
      }
      if (col === "2") {
        gap = 20;
      }
    }
    if (props.width) {
      if (props.width === "xs") {
        width = `calc((100% - ${gap}px)/4)`;
      }
      if (props.width === "sm") {
        width = `calc((100% - ${gap}px)/3)`;
      }
      if (props.width === "md") {
        width = `calc((100% - ${gap}px)/2)`;
      }
      if (props.width === "lg") {
        width = `calc(((100% - ${gap}px)/3)*2)`;
      }
      if (props.width === "xl") {
        width = `calc(((100% - ${gap}px)/4)*3)`;
      }
    }
    return `
    ${!props.noMargin && ` margin-bottom:${current.gXL};`};
    ${props.fullHeight && ` height:100%`};
    ${props.height === "Half" && ` height:calc((100% - 40px)/2)`};
    width:${width};
    ${current.mMX_MD}{
      width:100%;
      ${props.noMargin && ` margin-bottom:${current.gXL};`};
    }
    ${current.mMX_FOOTER}{
      width:100%;
      ${props.noMargin && ` margin-bottom:${current.gXL};`};
    }
  `;
  }}
`;

export const AlertMessage = styled.div`
  ${(props) => {
    let current = props.theme;
    return `
    display:flex;
    flex-direction:column;
    >span{
      color:rgb(${current.green});
      margin-bottom:${current.gMD};
    }
    >b{
      color:rgb(${current.red});
      margin-bottom:${current.gMD};
    }
    >div{
      display:flex;
      margin-bottom:${current.gSM};
      >span{
        margin-right:${current.gMD};
      }
    }
  `;
  }}
`;

export const DateTimeStyled = styled.div`
  ${(props) => {
    return `
    display: flex;
    justify-content: space-between;
    align-items: center;
    >div{
      width:calc((100% - 20px)/2)
    }
  `;
  }}
`;

export const MainIcon = styled.div`
  ${(props) => {
    let current = props.theme;
    return `
    background:rgba(${current.blueGray},${props.colorShade});
    ${
      props.color &&
      `
      background:#${props.color};
    `
    };
    display: flex;
    justify-content: center;
    align-items: center;
    padding:0 ${current.gSM};
    width:36px;
    >img, >svg{
      width:25px;
      height:auto;
      color:rgb(${current.white});
    }
  `;
  }}
`;

export const AboutEquipmentDetail = styled.div`
  ${(props) => {
    let current = props.theme;
    return `
    display:flex;
    flex-wrap:wrap;
    .status{
      width:150px;
      margin.right:${current.gMD};
      display:flex;
      flex-direction:column;
      align-items:center;
      >div{
        background:#${props.color};
        display:flex;
        align-items:center;
        justify-content:center;
        width:120px;
        height:120px;
        padding:${current.gXL};
        border-radius:50%;
        color:rgb(${current.white});
        margin-bottom:${current.gMD};
        >img{
          width:100%;
          height:auto;
        }
      }
      font-weight:bold;
    }
    `;
  }}
`;

export const InProgressStyled = styled.div`
  ${(props) => {
    let current = props.theme;
    return `
        position:absolute;
        display:flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 100%;
        background:rgba(${current.black},0.05);
    `;
  }}
`;

export const AboutEquipment = styled.div`
  ${(props) => {
    let current = props.theme;
    return `
      flex-grow:1;
      padding:${current.gMD};
      display:flex;
      flex-direction:column;
      >div{
        display:flex;
        align-items:flex-start;
        margin-bottom:${current.gMD};
        >svg{
          width:20px;
          margin-right:${current.gSM};
          color:rgba(${current.cOne});
        }
        >span{
          display:flex;
          flex-direction:column;
          flex-grow:1;
        }
      }
      
    `;
  }}
`;

export const IconListDetailStyled = styled.div`
  ${(props) => {
    let current = props.theme;
    return `
    width:100%;
    overflow:auto;
    -webkit-overflow-scrolling: touch;
    margin-bottom:${current.gMD};
    .wrapper{
        display:flex;
        flex-wrap:wrap;
        width:8000px;
        margin-top:${current.gSM};
        >div{
            background:rgba(${current.black},0.4);
            margin:1px;
            border-radius:4px;
            padding:${current.gSM};
            display: flex;
            cursor:pointer;
            >img{
                width:30px;
                height:30px;
            }
        }
        >div.current{
            background:rgb(${current.cOne});
        }
    }
    `;
  }}
`;

export const PointsWithTechnicianStyled = styled.div`
  ${(props) => {
    let current = props.theme;
    return `
    display:flex;
    width:100%;
    height:${props.height}px;
    flex-direction:column;
    >b{
      margin:${current.gMD};
    }
    >p{
      margin:0 ${current.gMD};
      color:rgb(${current.red});
    }
    `;
  }}
`;

export const EmptyList = styled.div`
  ${(props) => {
    let current = props.theme;
    return `
      height:100%;
      width:100%;
      display:flex;
      padding: ${current.gMD};
      justify-content: center;
      align-items: center;
      color:rgb(${current.red});
    `;
  }}
`;

export const CurrentLocationStyled = styled.div`
  ${(props) => {
    let current = props.theme;
    return `
      bottom: 182px;
      right: 10px;
      position: absolute;
      width: 40px;
      height: 40px;
      cursor: pointer;
      background: rgb(${current.white});
      box-shadow: 0 2px 2px rgba(${current.black}, 0.1);
      display: flex;
      justify-content: center;
      align-items: center;
      :hover{
        color:rgba(${current.green});
      }
  `;
  }}
`;

export const DirectionsStyled = styled.div`
  ${(props) => {
    let current = props.theme;
    return `
      bottom: 227px;
      right: 10px;
      position: absolute;
      width: 40px;
      height: 40px;
      cursor: pointer;
      background: rgb(${current.white});
      box-shadow: 0 2px 2px rgba(${current.black}, 0.1);
      display: flex;
      justify-content: center;
      align-items: center;
      :hover{
        color:rgba(${current.green});
      }
  `;
  }}
`;

export const IframeStyled = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  min-height: 480px !important;
`;
